module.exports = __webpack_public_path__ + "img/icon_map_0_on_111.169feeb2.png";